import type { Form } from '../../../../common/types/form';
import type { Documentation } from '../../../../common/types/documentation';

import dateHoursFields from '../../../form/dateHoursFields';

const takeFurtherEducationForm: Form<Documentation> = {
  key: 'takeFurtherEducation',
  title: 'Fortbildung nehmen',
  fields: [
    ...dateHoursFields,
    {
      key: 'topic',
      label: 'Thema',
      fieldTypes: 'text',
    },
    {
      key: 'advisor',
      label: 'Beraterin',
      fieldTypes: 'text',
    },
  ],
};

export default takeFurtherEducationForm;
